import { useRouter } from 'next/router'
import { useCallback } from 'react'

const mathVaultUrlPartsOrdered = ['elevator', 'room', 'chest', 'level', 'activity'] as const

type TMathVaultPathObj = { [K in typeof mathVaultUrlPartsOrdered[number]]: string }

export default function useActivityPath(): {
  createActivityPath: (levelNo?: number, activityNo?: number) => string
  currentActivityPath: string
  currentActivityPathObject: TMathVaultPathObj
} {
  const { asPath } = useRouter()
  const currentActivityPathParts = asPath.split('/').slice(2)
  const currentActivityPath = currentActivityPathParts.join(':')

  const currentActivityPathObject = currentActivityPathParts.reduce((prev, curr, index) => {
    return { ...prev, [mathVaultUrlPartsOrdered[index]]: curr }
  }, {} as TMathVaultPathObj)

  const createActivityPath = useCallback(
    (levelNo?: number, activityNo?: number) => {
      const pathArr = asPath.split('/')

      if (levelNo) {
        pathArr[5] = String(levelNo)
      }
      if (activityNo) {
        pathArr[6] = String(activityNo)
      }

      return pathArr.join('/')
    },
    [asPath],
  )

  return { createActivityPath, currentActivityPath, currentActivityPathObject }
}
